{
	"title": "Bedrijfsgegevens",
	"description": "Naam, adres, KvK, btw-nummer, IBAN en logo zoals ze op de facturen staan.",
	"defaults": "Deze gegevens zijn nog niet opgeslagen. Facturen gebruiken ze nu zo, zonder IBAN. Vul je IBAN in en sla op.",
	"changed": "Iemand anders heeft de bedrijfsgegevens intussen opgeslagen. Laad ze opnieuw en voer je wijziging dan nog eens in.",
	"reload": "Opnieuw laden",
	"save": "Opslaan",
	"section": {
		"company": "Bedrijf",
		"address": "Adres",
		"registration": "KvK, btw en bank",
		"contact": "Contact",
		"contactDescription": "Onderaan de factuur. Laat leeg wat er niet op hoeft."
	},
	"field": {
		"name": "Officiële naam",
		"tradeName": "Handelsnaam",
		"tradeNameDescription": "Staat groot bovenaan de factuur. Leeg: alleen de officiële naam.",
		"street": "Straat en huisnummer",
		"postcode": "Postcode",
		"city": "Plaats",
		"country": "Land",
		"kvk": "KvK-nummer",
		"kvkDescription": "8 cijfers.",
		"vatId": "Btw-nummer",
		"vatIdDescription": "Zoals NL001234567B01.",
		"iban": "IBAN",
		"ibanDescription": "Spaties mag je laten staan.",
		"email": "E-mailadres",
		"phone": "Telefoonnummer",
		"website": "Website"
	},
	"logo": {
		"title": "Logo",
		"description": "Staat linksboven op elke nieuwe factuur. Facturen die er al zijn houden hun logo.",
		"alt": "Huidig logo",
		"none": "Geen logo",
		"upload": "Logo uploaden",
		"replace": "Ander logo",
		"remove": "Logo weghalen",
		"hint": "JPEG, PNG, WebP of AVIF, hoogstens 2 MB. Een liggend logo met een witte of transparante achtergrond werkt het best.",
		"tooLarge": "Dit bestand is groter dan 2 MB.",
		"notAnImage": "Dit is geen JPEG, PNG, WebP of AVIF.",
		"failed": "Uploaden lukte niet. Probeer het opnieuw."
	},
	"help": {
		"companyDetails": {
			"title": "Bedrijfsgegevens",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "Wie de shop verkoopt. Ze staan op elke nieuwe factuur en onderaan de mails, en in de shop in de footer, op de contactpagina en op de pagina voor bedrijven.",
			"warning": "Een factuur neemt de gegevens over als hij gemaakt wordt. Een wijziging geldt vanaf de volgende factuur; facturen die er al zijn, blijven zoals ze zijn.",
			"terms": ["companyDetails:contact"]
		},
		"logo": {
			"title": "Logo",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "Het logo linksboven op de factuur. Alleen daar: de shop en de mails hebben hun eigen logo.",
			"warning": "Een nieuw logo staat op de volgende factuur. Facturen die er al zijn, houden hun logo."
		},
		"company": {
			"title": "Bedrijf",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "De officiële naam is die uit het KvK-register. Heb je een handelsnaam, dan staat die groot bovenaan de factuur en als kop in de footer van de shop, met de officiële naam eronder."
		},
		"address": {
			"title": "Adres",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "Het adres van het bedrijf. Het staat op de factuur, onderaan de mails, en in de shop in de footer en op de contactpagina."
		},
		"registration": {
			"title": "KvK, btw en bank",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "Ze staan op de factuur en in de shop; het KvK-nummer ook onderaan de mails. De IBAN staat op de factuur en in de bevestiging van een bestelling op rekening: daarheen maakt de klant het bedrag over."
		},
		"contact": {
			"title": "Contact",
			"area": "Instellingen › Bedrijfsgegevens",
			"short": "Het e-mailadres en telefoonnummer van de klantenservice. Ze staan op de factuur en in de shop. Berichten van het contactformulier en antwoorden op mails aan klanten komen op dit e-mailadres binnen.",
			"warning": "Zonder e-mailadres kan een klant geen bericht sturen via het contactformulier."
		}
	}
}
